let domainReady

export function isExe() {
  return !!(window.appEnv && window.appEnv.isExe)
}

export function BASEURL() {
  if (isExe()) return window.localStorage.getItem('get_app_domain') || process.env.VUE_APP_BASE_API
  const { protocol, hostname, origin } = window.location
  // The local Vue development server has no backend API.
  if (!/^https?:$/.test(protocol) || ['localhost', '127.0.0.1', '[::1]'].includes(hostname)) {
    return process.env.VUE_APP_BASE_API
  }
  return origin
}

export function resourceUrl(value, base = BASEURL()) {
  if (!value) return ''
  try {
    const url = new URL(String(value), base)
    return ['http:', 'https:'].includes(url.protocol) ? url.href : ''
  } catch (_) { return '' }
}

export function initBaseURL() {
  if (!isExe()) return Promise.resolve(BASEURL())
  if (!domainReady) {
    const pending = window.appEnv.getApiDomain(window.localStorage.getItem('get_app_domain'), process.env.VUE_APP_BASE_API).then(domain => {
      if (domainReady !== pending) return BASEURL()
      window.localStorage.setItem('get_app_domain', domain)
      return domain
    }).catch(error => {
      if (domainReady !== pending) return BASEURL()
      domainReady = null
      throw error
    })
    domainReady = pending
  }
  return domainReady
}

export function selectBaseURL(domain) {
  const url = new URL(domain)
  if (!isExe() || !/^https?:$/.test(url.protocol) || url.username || url.password) throw new Error('Invalid API domain')
  window.localStorage.setItem('get_app_domain', url.origin)
  domainReady = Promise.resolve(url.origin)
}
